import type { Nil } from "@mcwd/typescript-type-guards";

export const SocialMediaName = [ "linkedin", "facebook", "twitter", "youtube" ] as const;
export type SocialMediaName = typeof SocialMediaName[number];

export function getSocialMediaName (externalReferrer: string): SocialMediaName | Nil {
  const name = SocialMediaName.find(val => externalReferrer.includes(val as string));
  return name ?? null;
}